import { render, staticRenderFns } from "./SoliVideoPlayer.vue?vue&type=template&id=594d9b87&scoped=true"
import script from "./SoliVideoPlayer.vue?vue&type=script&lang=js"
export * from "./SoliVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./SoliVideoPlayer.vue?vue&type=style&index=0&id=594d9b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d9b87",
  null
  
)

export default component.exports